// Copyright (c) 2016 Deere & Company

import ClaimHistoryReport from '../../../reports/claim-history/state-connector';

export default {
    component: ClaimHistoryReport,
    name: 'CLAIM_HISTORY',
    path: 'claim-history'
};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/claim-history.js